import { useEffect, useState } from 'react';

export interface UserInfo {
  name: string;
  username: string;
  roleCode: string;
  userId?: number;
  roleId?: number;
  userProfileImageUri?: string;
  merchantId?: number;
  merchantCode?: string;
  programIds?: number[];
  programCodes?: string[];
  applicationAccess?: string[];
}

export function useUserInfo() {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    const storedUserInfo = sessionStorage.getItem('userInfo');
    if (storedUserInfo) {
      try {
        setUserInfo(JSON.parse(storedUserInfo));
      } catch (error) {
        console.error('Error parsing user info:', error);
      }
    }
  }, []);

  const getUserInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase();
  };

  const formatName = (name: string) => {
    if (!name) return '';
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const formatRole = (roleCode: string) => {
    if (!roleCode) return '';
    return roleCode
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return {
    userInfo,
    getUserInitials,
    formatName,
    formatRole
  };
} 